
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

window.$ = window.jQuery = require('jquery')
import { isMobile } from "mobile-device-detect"
import "@js/lib/bootstrap"
import "@js/lib/plugins"
import VueSignaturePad from "vue-signature-pad"

require("datatables.net");
require("datatables.net-responsive");

// Global Ambition API
import '@api'

import store from '@store';

// Theme styling
import SlimCropper from "@shared/components/slim/slim.vue";
import SlimMulti from "@shared/components/slim/slimMulti.vue";
import VueMoment from "vue-moment";
import moment from "moment-timezone";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import locale from "element-ui/lib/locale/lang/en";
import vueScrollto from "vue-scrollto";
import VueDraggableResizable from "vue-draggable-resizable";
import Vuelidate from "vuelidate";

import {
  FontAwesomeIcon,
  FontAwesomeLayers,
  FontAwesomeLayersText
} from "@fortawesome/vue-fontawesome";


import Vue from 'vue'
window.Vue = Vue;

// Vue.component('pagination', Pagination);/* npm component for vue-tables-2 */

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

Vue.use(VueMoment, { moment })
Vue.use(ElementUI, { locale })
Vue.use(vueScrollto)
Vue.use(VueSignaturePad)

import BootstrapVue from "bootstrap-vue"
import '@shared/lib/Filters';
import components from '@shared/components'
import partials from '@shared/partials'

Vue.use(partials)
Vue.use(components)
Vue.use(BootstrapVue)
Vue.use(Vuelidate);

import Message from "@shared/components/message"
import PDFDataCustom from '@shared/components/pdf/PDFDataCustom.vue'
Vue.component("pdf-data-custom", PDFDataCustom);

import PDFDocumentShow from '@shared/components/pdf/PDFDocumentShow.vue'
Vue.component("pdf-document-show", PDFDocumentShow);

import VideoChat from "@shared/components/video/VideoChat.vue"
Vue.component("video-chat", VideoChat);

Vue.component("font-awesome-icon", FontAwesomeIcon)
Vue.component("font-awesome-layers", FontAwesomeLayers);
Vue.component("font-awesome-layers-text", FontAwesomeLayersText);

import VueDropzone from 'vue2-dropzone'
Vue.component("vue-dropzone", VueDropzone);

Vue.component("page-viewer", require("./components/PageViewer.vue").default);
Vue.component("user-page-viewer", require("./components/UserPageViewer.vue").default)
Vue.component("vue-draggable-resizable", VueDraggableResizable);
Vue.component("authentication-card", require("./components/Authentication.vue").default);
Vue.component(
    "application-modal",
    require("@tenant/ambition/components/form-elements/ApplicationModal.vue").default
);

Vue.component(
    "authentication2fa-card",
    require("./components/Authentication2fa.vue").default
);

Vue.component("signature-pad", require("./components/SignaturePad.vue").default);
Vue.component("user-signature-pad", require("./components/UserSignaturePad.vue").default)
Vue.component(
    "signature-statement",
    require("./components/SignatureStatement.vue").default
);

Vue.component('basic-signature', require('./components/basics/Signature.vue').default);
// Vue.component("timeline", require("./components/Timeline.vue"));

Vue.component('file-upload', require('./components/FileUpload').default)
Vue.component(SlimCropper.name, SlimCropper)
Vue.component(SlimMulti.name, SlimMulti)

Vue.component('conditioning-objectives', require('./components/ConditioningSignOff/Objectives').default);
Vue.component('insurance-deal-documents', require('./view/InsuranceDealDocuments').default);
Vue.component("condition-sign-off", require("./view/conditionSignOff").default)

Vue.prototype.$message = Message
Vue.prototype.$isMobile = isMobile

let eventBus = {
    install(Vue, options) {
        Vue.prototype.$bus = new Vue();
    }
};
Vue.use(eventBus);

var app = new Vue({
    el: "#app",
    data: {
        showModal: false
    },
    store
});
